/**
* @Author: MSL_Chaos <dmitriymikhaylov>
* @Date:   2016-10-09T01:16:15+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   dmitriymikhaylov
* @Last modified time: 2016-10-10T07:49:20+03:00
* @License: MIT
*/



import React, { Component } from 'react'
import { connect } from 'react-redux'


let select = state => state

export class Popup extends Component{
  componentWillUnmount(){

  }
  render(){
    let { hideItem, item } = this.props.popup
    return(
      <div className="popup-holder">
        {(item.notifyMessage)?
          <div
            className="notification show"
          >
            {item.notifyMessage}
          </div>
          :""
        }
        {(hideItem.notifyMessage)?
          <div
            className="notification out"
          >
            {hideItem.notifyMessage}
          </div>
          :""
        }
      </div>
    )
  }
}

export default connect(select)(Popup)



// WEBPACK FOOTER //
// ./src/components/ListLayoutParts/PopupNotification.js